import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";

interface ISupportModal {
  open: boolean;
  close?: () => void;
}

const SupportModal = ({ open, close }: ISupportModal) => {
  return (
    <Modal open={open} onChange={close}>
      <div className="w-[500px] flex flex-col items-center pt-6 justify-center gap-6 text-center">
        <p className="font-poppins text-xl font-semibold w-fit">Contact Support</p>
        <p className="font-poppins text-[18px] font-semibold leading-[36px]">
          For support, please email us at{" "}
          <span className="text-odfblue">support@outdefine.com</span> - We're here to help!
        </p>
        <p className="font-poppins font-medium text-base text-[#8a8a8a] leading-[36px]">
          An email will be sent to the outdefine support and we will connect with you as soon as
          possible
        </p>
        <Button shapeVariant={2} onClick={close}>
          Okay, thanks
        </Button>
      </div>
    </Modal>
  );
};

export default SupportModal;
